import type { CSSProperties } from 'react';

export const activeNavItemStyle: CSSProperties = {
  background: 'linear-gradient(100deg, #2E3F6E 0%, #102653 100%)',
  boxShadow: '0 8px 18px rgba(16, 38, 83, 0.22)',
};

export const dropdownContentClass =
  'min-w-[220px] border-[#E7EAF0] bg-white text-[#4B5563] shadow-[0_18px_45px_rgba(17,24,39,0.12)]';
